import dayjs from 'dayjs';
import dayjsUTC from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(dayjsUTC);
dayjs.extend(dayjsTimezone);
dayjs.extend(relativeTime);

/**
 * Gets the hour in local time zone from a date that is in UTC time zone
 */
export const getHourFromDate = (date: string) => {
    if (!date) {
        return '';
    }

    const utcDate = dayjs(date, { utc: true });
    const localDate = utcDate.tz(dayjs.tz.guess());
    return localDate.format('h:mm A');
};

export const timeAgo = (dateString: string) => {
    return dayjs(dateString).fromNow();
};
